// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"exNZUG"};